<template>
  <div id="studyDetail">
    <page-header :noBack="true">
      课程详情
    </page-header>
    <div class="infos">
      <div class="imgs">
        <img class="img" :src="course.bigpic || course.bigcover" alt="">
      </div>
      <div class="info">
        <div class="title">{{course.interestcoursenamae || course.coursename}}</div>
        <div class="nums">{{course.studypeople || 0}}人在学习</div>
      </div>
    </div>
    <div class="navs">
      <div class="nav" :class="{'active': navIndex === index}" v-for="(item, index) in navs" :key="index" @click="navToggle(index)">
        {{item}}
      </div>
    </div>
    <div class="details" v-if="navIndex === 0">
      <div class="title">课程介绍</div>
      <div class="content" v-html="course.coursedetail || course.detail"></div>
    </div>
    <div class="class_wrap" v-if="navIndex === 1">
      <div class="class_lists">
        <div class="class_list" v-for="(item, index) in lists" :key="index">
          <div class="list_info" @click="classToggle(index)">
            <div class="title">{{item.chaptername}}</div>
            <img class="icon" :class="{'isUp': item.isShow}" src="../assets/img/icon_xia.png" alt="">
          </div>
          <div class="children_lists" v-if="item.isShow">
            <div class="list" v-for="(item1, index1) in item.children" :key="index1">
              <div class="titles">
                <div class="title">{{item1.chaptercoursename}}</div>
                <div class="is_must" v-if="item1.iscompulsory === 1">必修</div>
              </div>
              <div class="desc">{{item1.knowledgedescribe}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment_wrap" v-if="navIndex === 2">
      <div class="title">全部评价</div>
      <div class="comment_lists">
        <div class="list" v-for="(item, index) in comments" :key="index">
          <div class="list_top">
            <div class="list_infos">
              <div class="headimg">
                <img class="img" :src="item.userpic" alt="">
              </div>
              <div class="name">{{item.usernick}}</div>
            </div>
            <div class="nums">
              <div class="stars">
                <div class="star" v-for="(item1, index1) in 5" :key="index1">
                  <img src="../assets/img/icon_star_active.png" alt="" v-if="item.starcount > index1">
                  <img src="../assets/img/icon_star.png" alt="" v-else>
                </div>
              </div>
              <div class="time">{{item.createtime}}</div>
            </div>
          </div>
          <div class="list_content">{{item.comments}}</div>
        </div>
      </div>
    </div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "studyDetail",
  data() {
    return {
      type: Number(this.$route.query.type) || 2,
      id: this.$route.query.id || '4cfcacd6c9d94b3886944557b1b1eb29',
      course: {},
      navs: ['介绍', '目录', '评论'],
      navIndex: 0,
      lists: [],
      comments: []
    };
  },
  mounted () {
    this.getInfo();
    this.getList();
    this.getComment();
  },
  methods: {
    navToggle (index) {
      this.navIndex = index;
    },
    getInfo () {
      let url;
      if (this.type === 1) {
        url = '/xxgf-api/study/getAcademicCourseDetailById';
      } else {
        url = '/xxgf-api/study/getInterestClassDetailByCourseId';
      }
      this.axios.get(url, {
        params: {
          id: this.id,
          userid: '1'
        }
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.course = data.rows[0];
          }
        })
    },
    getList () {
      let url;
      if (this.type === 1) {
        url = '/xxgf-api/study/getAcademicChapterByCourseId';
      } else {
        url = '/xxgf-api/study/getInterestClassChapterById';
      }
      this.axios.get(url, {
        params: {
          id: this.id,
          pageNum: 1,
          pageSize: 100
        }
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.lists = data.rows;
          }
        })
    },
    getComment () {
      this.axios.get('/xxgf-api/study/getAcademicCommentsByCourseId', {
        params: {
          courseid: this.id,
          pageNum: 1,
          pageSize: 10,
          userId: '1'
        }
      })
        .then(({data}) => {
          if (data.code === 200) {
            this.comments = data.rows[0].commentList;
          }
        })
    },
    classToggle (index) {
      if (this.lists[index].children) {
        this.$set(this.lists[index], 'isShow', !this.lists[index].isShow);
      } else {
        let url;
        if (this.type === 1) {
          url = '/xxgf-api/study/getAcademicChapterCourses';
        } else {
          url = '/xxgf-api/study/getInterestChapterCourses';
        }
        this.axios.get(url, {
          params: {
            courseid: this.id,
            chapterid: this.lists[index].id
          }
        })
          .then(({data}) => {
            if (data.code === 200) {
              this.$set(this.lists[index], 'children', data.rows);
              this.$set(this.lists[index], 'isShow', true);
            }
          })
      }
    }
  }
};
</script>
<style lang="scss">
#studyDetail {
  padding-top: 94px;
  padding-bottom:120px;
  background:#fff;
  .infos{
    background:#fff;
    border-bottom:10px solid #e6e6e6;
    .imgs{
      width:100%;
      height:388px;
      img{
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .info{
      padding:30px;
      .title{
        font-size:40px;
        line-height:60px;
      }
      .nums{
        font-size:24px;
        color:#AAAAAA;
        margin-top:10px;
      }
    }
  }
  .navs{
    margin-top:10px;
    height:90px;
    display:flex;
    background:#fff;
    border-bottom:1px solid #e6e6e6;
    .nav{
      flex:1;
      line-height:90px;
      font-size:30px;
      text-align:center;
      &.active{
        color:#D72F1D;
        font-weight: bold;
        position:relative;
        &:after{
          content:'';
          display:block;
          width:40px;
          height:3px;
          background:#D72F1D;
          border-radius: 2px;
          position:absolute;
          bottom:0;
          left:50%;
          margin-left:-20px;
        }
      }
    }
  }
  .details{
    background:#fff;
    padding:30px;
    .title{
      font-size:36px;
      line-height:80px;
      font-weight: bold;
    }
  }
  .class_wrap{
    background:#fff;
    .class_lists{
      .class_list{
        .list_info{
          height:88px;
          display:flex;
          align-items: center;
          justify-content: space-between;
          padding:0 30px;
          border-bottom:1px solid #e6e6e6;
          .title{
            font-size:28px;
          }
          .icon{
            width:20px;
            height:20px;
            &.isUp{
              transform: rotateX(180deg);
            }
          }
        }
        .children_lists{
          .list{
            min-height:120px;
            padding:0 30px;
            display:flex;
            align-items: center;
            align-content: center;
            flex-wrap: wrap;
            .titles{
              width:100%;
              display:flex;
              align-items: center;
              .title{
                font-size:28px;
                margin-right:15px;
              }
              .is_must{
                width:88px;
                height:40px;
                border-radius: 20px;
                border:1px solid #BABABA;
                line-height:40px;
                text-align:center;
                font-size:24px;
                color:#777777;
              }
            }
            .desc{
              font-size:22px;
              color:#999999;
            }
          }
        }
      }
    }
  }
  .comment_wrap{
    padding: 30px;
    .title{
      font-size:36px;
      line-height:80px;
    }
    .comment_lists{
      .list{
        margin-bottom:20px;
        .list_top{
          display:flex;
          align-items: center;
          justify-content: space-between;
          .list_infos{
            display:flex;
            align-items: center;
            .headimg{
              width:80px;
              height:80px;
              border-radius: 50%;
              overflow: hidden;
              margin-right:30px;
              .img{
                width:100%;
                height:100%;
                object-fit: cover;
              }
            }
            .name{
              font-size:28px;
              color:#333;
              width:300px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .nums{
            text-align: right;
            .stars{
              display:flex;
              align-items: center;
              .star{
                width:34px;
                height:34px;
                margin-left:15px;
                img{
                  width:100%;
                  height:100%;
                  display:block;
                }
              }
            }
            .time{
              color:#AAAAAA;
              font-size:22px;
            }
          }
        }
        .list_content{
          padding-left:110px;
          margin-top:20px;
          font-size:30px;
        }
      }
    }
  }
}
</style>
